export const ASSETS = '/assets'
export const ERROR_PAGE_PATH = '/error'
export const LOCAL_BLOG_IMAGE_URL = `${ASSETS}/default/blogs`
export const PRODUCT_NOT_FOUND = '/product-not-found'
export const BLOG_NOT_FOUND = '/blog-not-found'
